import { useState } from 'react';
import { Link } from 'react-router-dom';
import NetworkBackground from '../../components/NetworkBackground';
import authService from '../../services/authService';
import styles from './ForgotPasswordPage.module.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const result = await authService.forgotPassword(email);
    setLoading(false);
    if (result.success) {
      setSubmitted(true);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.card}>
        <div className={styles.logoContainer}>
          <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
          <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
        </div>

        {submitted ? (
          <>
            <div className={styles.iconWrapper}>
              <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h1 className={styles.title}>Check your email</h1>
            <p className={styles.message}>
              If <strong>{email}</strong> is registered, you'll receive a password reset link shortly. Check your spam folder if it doesn't arrive.
            </p>
            <Link to="/login" className={styles.backLink}>Back to Login</Link>
          </>
        ) : (
          <>
            <h1 className={styles.title}>Forgot password?</h1>
            <p className={styles.message}>Enter your email and we'll send you a reset link.</p>

            {error && <div className={styles.errorMessage}>{error}</div>}

            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                className={styles.input}
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <button type="submit" className={styles.button} disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <div className={styles.divider}></div>
            <div className={styles.footerText}>
              <Link to="/login">Back to Login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
